// Simple client-side logging utility
interface LogEntry {
  timestamp: string;
  level: "error" | "warn" | "info" | "debug";
  message: string;
  context?: Record<string, any> | undefined;
}

const logs: LogEntry[] = [];
const MAX_LOGS = 100;

export const logger = {
  error(message: string, context?: Record<string, any>) {
    const entry = { timestamp: new Date().toISOString(), level: "error" as const, message, context };
    logs.push(entry);
    if (logs.length > MAX_LOGS) logs.shift();
    console.error(`[ERROR] ${message}`, context);
  },

  warn(message: string, context?: Record<string, any>) {
    const entry = { timestamp: new Date().toISOString(), level: "warn" as const, message, context };
    logs.push(entry);
    if (logs.length > MAX_LOGS) logs.shift();
    console.warn(`[WARN] ${message}`, context);
  },

  info(message: string, context?: Record<string, any>) {
    const entry = { timestamp: new Date().toISOString(), level: "info" as const, message, context };
    logs.push(entry);
    if (logs.length > MAX_LOGS) logs.shift();
    console.info(`[INFO] ${message}`, context);
  },

  debug(message: string, context?: Record<string, any>) {
    const entry = { timestamp: new Date().toISOString(), level: "debug" as const, message, context };
    logs.push(entry);
    if (logs.length > MAX_LOGS) logs.shift();
    if (import.meta.env.DEV) console.debug(`[DEBUG] ${message}`, context);
  },

  getLogs(): LogEntry[] {
    return [...logs];
  },

  clearLogs() {
    logs.length = 0;
  }
};
